import { createFileRoute } from "@tanstack/react-router";
import { DevUiPage } from "@/pages/dev/DevUiPage";

export const Route = createFileRoute("/dev/ui")({ component: DevUiPage });
